import React, { useContext } from 'react';
import { PatrimonioContext } from '../../../contexts/patrimonioProvider';
import BaseInput from '../../General/FormsComp/Input/BaseInput';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';
import BaseButton from '../../General/FormsComp/Button/BaseButton';


const optionsMonth = [
    { id: '1', nome: 'Janeiro' },
    { id: '2', nome: 'Fevereiro' },
    { id: '3', nome: 'Março' },
    { id: '4', nome: 'Abril' },
    { id: '5', nome: 'Maio' },
    { id: '6', nome: 'Junho' },
    { id: '7', nome: 'Julho' },
    { id: '8', nome: 'Agosto' },
    { id: '9', nome: 'Setembro' },
    { id: '10', nome: 'Outubro' },
    { id: '11', nome: 'Novembro' },
    { id: '12', nome: 'Dezembro' }
]


const defaultItem = {
    descricao: '',
    codigo: '',
    tipo: '',
    quantidade_contratada: '',
    quantidade_implantada: '',
    grupo: '',
    unidade: '',
    valor_unitario: ''
}
const CadastrarItens = ({ newClient, handleInputChange }) => {
    const { grupos } = useContext(PatrimonioContext);

    const handleItemChange = (index, field, value) => {
        const updatedItens = newClient.itens?.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        handleInputChange({ target: { name: 'itens', value: updatedItens } });
    };

    const addItem = () => {
        const newItem = defaultItem;
        newClient.itens = newClient.itens || [];
        const updatedItens = [...newClient.itens, newItem];
        handleInputChange({ target: { name: 'itens', value: updatedItens } });
    };

    const removeItem = (index) => {
        const updatedItens = newClient.itens?.filter((_, i) => i !== index);
        handleInputChange({ target: { name: 'itens', value: updatedItens } });
    };

    const tipoOptions = [
        { id: 'Equipamento', nome: 'Equipamento' },
        { id: 'Licença', nome: 'Licença' },
        { id: 'Linhas', nome: 'Linhas' },
        { id: 'Serviço', nome: 'Serviço' },
        { id: 'Minutos', nome: 'Minutos' },
        { id: 'Valor', nome: 'Valor' }
    ];

    const unidadeOptions = [
        { id: 'Mês', nome: 'Mês' },
        { id: 'Unitário', nome: 'Unitário' },
        { id: 'Minutos', nome: 'Minutos' },
        { id: 'Única', nome: 'Única' }
    ];

    return (
        <div className="w-full space-y-6">
            {newClient.itens?.map((item, index) => (
                <div
                    key={index}
                    className="border border-gray-200 rounded-lg p-6 space-y-4"
                >
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div className="md:col-span-2 lg:col-span-3">
                            <BaseInput
                                label="Descrição"
                                value={item.descricao}
                                onChange={(e) =>
                                    handleItemChange(index, 'descricao', e.target.value)
                                }
                                type="textarea"
                                rows={3}
                                required
                            />
                        </div>
                        {/* <BaseInput
                            label="Código"
                            value={item.codigo}
                            onChange={(e) =>
                                handleItemChange(index, 'codigo', e.target.value)
                            }
                            type="text"
                        /> */}

                        <BaseSelect
                            label="Tipo"
                            value={item.tipo}
                            onChange={(e) =>
                                handleItemChange(index, 'tipo', e.target.value)
                            }
                            options={tipoOptions}
                            placeholder="Selecione o tipo"
                            valueKey="id"
                            labelKey="nome"
                            required
                        />
                        <BaseInput
                            label="Valor Unitário"
                            value={item.valor_unitario}
                            onChange={(e) => {
                                const val = e.target.value.replace(',', '.');
                                if (!isNaN(val)) handleItemChange(index, 'valor_unitario', val)
                            }}
                            type="number"
                            step="0.01"
                            required
                        />

                        <BaseSelect
                            label="Grupo"
                            value={item.grupo}
                            onChange={(e) =>
                                handleItemChange(index, 'grupo', e.target.value)
                            }
                            options={grupos}
                            placeholder="Selecione um grupo"
                            valueKey="id"
                            labelKey="nome"
                            required
                        />

                        <BaseSelect
                            label="Unidade"
                            value={item.unidade}
                            onChange={(e) => {
                                const updatedItens = newClient.itens?.map((item, i) =>
                                    i === index ? { ...item, unidade: e.target.value, quantidade_contratada: '' } : item
                                );
                                handleInputChange({ target: { name: 'itens', value: updatedItens } });
                            }}
                            options={unidadeOptions}
                            placeholder="Selecione a unidade"
                            valueKey="id"
                            labelKey="nome"
                            required
                        />
                        {item.unidade === 'Única' ? (
                            <BaseSelect
                                label="Mês"
                                value={item.quantidade_contratada}
                                onChange={(e) =>
                                    handleItemChange(index, 'quantidade_contratada', e.target.value)
                                }
                                options={optionsMonth}
                                placeholder="Selecione o mês"
                                valueKey="id"
                                labelKey="nome"
                                required
                            />
                        ) : (
                            <BaseInput
                                label="Quantidade Contratada"
                                value={item.quantidade_contratada}
                                onChange={(e) =>
                                    !isNaN(e.target.value) &&
                                    handleItemChange(index, 'quantidade_contratada', e.target.value)
                                }
                                type="number"
                                required
                            />
                        )}


                    </div>
                    <div className="flex justify-end">
                        <BaseButton
                            onClick={() => removeItem(index)}
                            variant="danger"
                            size="sm"
                        >
                            Remover Item
                        </BaseButton>
                    </div>
                </div>
            ))}
            <div className="flex justify-center">
                <BaseButton
                    onClick={addItem}
                    variant="secondary"
                    size="md"
                >
                    Adicionar Item
                </BaseButton>
            </div>
        </div>
    );
};

export default CadastrarItens;
